import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { V2AdminService } from "../../../services/api/v2-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class BillableProposalsEffects {
	constructor(
		private actions$: Actions,
		private adminService: V2AdminService
	) {}

	getBillableProposals = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.billableProposals.getApi),
			switchMap(() =>
				this.adminService.proposalsReadyForInvoicing().pipe(
					map((proposals) => MpAdminActions.billableProposals.getSuccess({ proposals })),
					catchError((error) =>
						of(MpAdminActions.billableProposals.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	// Re-fetch billable proposals when an invoice is deleted
	refetchProposalsOnInvoiceDeletion = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.invoices.deleteSuccess),
			map(() => MpAdminActions.billableProposals.getApi())
		)
	);
}
